module.exports = __webpack_public_path__ + "img/图片10.50053c01.png";